<style>
  .p-datatable-thead ng-star-inserted{
  font-size: smaller;
}
</style>

<div class="n-breadcrumb d-flex align-items-center justify-content-between">
    <ol class="breadcrumb m-0 bg-transparent p-0">
      <li class="breadcrumb-item"><a href="/#/dealer/home">Home</a></li>
      <li class="breadcrumb-item"><a href="/#/reports/home">Reports</a></li>
      <li class="breadcrumb-item active">Client Files Postage Tracking Report</li>
  
    </ol>
  
  </div>
  <div class="panel-tile main-title d-flex align-items-center justify-content-between">
    <h3 style="border: 0px !important;margin: 0;padding: 0 !important;" i18n>Client Files Postage Tracking Report </h3>
  
  </div>
  <!-- <div class="panel-group search-criteria mb-1" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default bg-white m-0">
      <div class="panel-heading" role="tab" id="headingTwo" (click)="searchClick(show=!show)" data-toggle="collapse"
        data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        <h6 class="panel-title1 d-flex align-items-center justify-content-between"
          style="padding: 11px 15px; line-height: 1.1; font-size: 15px;">
          <span>Search Criteria</span>
          <a class="collapsed" role="button" style="font-size: 22px;">
            <i class="{{toggleClass}}"></i>
          </a>
        </h6>
      </div>
      <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
        <div class=" form-group d-flex p-2 ">
          <div class="d-inline-block m-2">
            <select class="form-control" [(ngModel)]="client" (change)="bindClientSubscriptionsInfo()">
              <option value="All" selected>All Clients</option>
              <option *ngFor="let client of clients" [value]="client.ClientName">
                {{client.ClientName}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="n_cardList">
    <div class="tcard">
      <div class="tcard-body">
          <div class="prime-table p-0">
              <p-table #dt [columns]="dataGapCol" [value]="dataGapList" [paginator]="true" [pageLinks]="3" styleClass="p-datatable-exportFilesList p-datatable-gridlines"
                  [rowsPerPageOptions]="[5,10,20]" [rows]="10" [responsive]="true" class="mytable" >
                <ng-template pTemplate="caption">
                  <div class="row">
                    <div class="p-d-flex" style="float: left;">
                      <span class="p-input-icon-left p-ml-auto">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" style="width: 454px;" (input)="dt.filterGlobal($event.target.value, 'contains')"
                          placeholder="Search by OEM, Clien Name, Natural key, Dealer Name, Data Source" class="p-inputtext p-component" />
                      </span>
                    </div>
                    <div class="p-d-flex" style="float: right;">
                    <button type="button" class="btn" (click)="ClientFilePostageDetailsExport()" data-toggle="tooltip" data-placement="top"
                      title="Export to Excel">
                      <i class="fa fa-file-excel-o" aria-hidden="true" style="font-size: 24px;"></i>
                    </button>
                  </div>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="colgroup">
                      <colgroup>
                          <col style="width: 0.2em;">
                          <col style="width:0.31em">
                          <col style="width:0.31em">
                          <col style="width:0.6em">
                          <col style="width:0.31em">
                          <col style="width:0.31em">
                          <col style="width:0.31em">
                          <col style="width:0.31em"> 
                          <col style="width:0.31em">                                 
                        </colgroup>
                    </ng-template>
                  <ng-template pTemplate="header" let-columns>
                      <tr>
                          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                              {{col.header}}
                              <p-sortIcon field="col.field"></p-sortIcon>
                          </th>
                      </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-rowData let-columns="columns">
                      <tr>
                          <td *ngFor="let col of columns">
                            <div *ngIf="col.field != 'LastSaleFilePostedDate' 
                                        && col.field != 'LastServiceFilePostedDate'
                                        && col.field != 'LastCustomerFilePostedDate'
                                        && col.field != 'LastOpcodeFilePostedDate'">
                              {{rowData[col.field]}}
                            </div>
                              
                              <div *ngIf="col.field == 'LastSaleFilePostedDate'">
                                {{rowData.LastSaleFilePostedDate | date:'MM/dd/yyyy'}}
                            </div>
                            <div *ngIf="col.field == 'LastServiceFilePostedDate'">
                              {{rowData.LastServiceFilePostedDate | date:'MM/dd/yyyy'}}
                          </div>
                          <div *ngIf="col.field == 'LastCustomerFilePostedDate'">
                            {{rowData.LastCustomerFilePostedDate | date:'MM/dd/yyyy'}}
                        </div>
                        <div *ngIf="col.field == 'LastOpcodeFilePostedDate'">
                          {{rowData.LastOpcodeFilePostedDate | date:'MM/dd/yyyy'}}
                      </div>
                          </td>
                      </tr>
                  </ng-template>
                  
                  <ng-template pTemplate="emptymessage">
                      <tr>
                          <td colspan="7">No records found.</td>
                      </tr>
                  </ng-template>
              </p-table> 
          </div>
      </div>
  </div>    
  </div>
  